<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $t('message.currentTreatments') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="description-group"
                                        :label="$t('message.description')"
                                        label-for="description"
                                >
                                    <b-form-textarea
                                            id="description"
                                            v-model="$v.form.description.$model"
                                            :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                            required
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="$v.form.description.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.description.minLength">
                                        {{ $t('message.minCharacters', { n: 4 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('description')">
                                        {{ getErrorsField('description') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

                        </b-row>
                    </b-container>



                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';

    export default {
        name: "EditTreatment",

        computed: {
            ...mapGetters(["traitement",'errors',
                'hasAdminRole',
                'hasMedecinControleRole', 'hasAssistante',
                'hasPraticienRole',
            ]),
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
            form: function() {
                return this.traitement;
            }
        },

        data() {
            return {
                treatment_id: this.$route.params.treatment,
                show: true
            }
        },

        methods: {
            getTreatment: function() {
                let args = {
                    treatment: this.treatment_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getTraitement', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        dossier_medical_id: this.form.dossier.id,
                        description: this.form.description,
                        treatment:this.treatment_id
                    };

                    let successMessage = this.$i18n.t('message.currentTreatmentsUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateActuelTraitement', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
               //
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
        },

        validations: {
            form: {
                description: {
                    required,
                    minLength:minLength(4)
                }
            }
        },

        mounted() {
            // Retrieve treatment
            this.getTreatment();
        }
    }
</script>

<style scoped>

</style>